import { render, staticRenderFns } from "./joinNum.vue?vue&type=template&id=0af77244&scoped=true&"
import script from "./joinNum.vue?vue&type=script&lang=js&"
export * from "./joinNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af77244",
  null
  
)

export default component.exports